import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=71ae2266&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=71ae2266&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae2266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ae2266')) {
      api.createRecord('71ae2266', component.options)
    } else {
      api.reload('71ae2266', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=71ae2266&scoped=true&", function () {
      api.rerender('71ae2266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/Tag.vue"
export default component.exports